import { useCallback, useState } from "react";
/**
 * A hook that implements the base functionality for expanding different tree
 * items.
 *
 * @param defaultExpandedIds - Either a list of tree item ids to be expanded by
 * default or a function that will return the list of tree item ids to be
 * expanded by default
 * @returns An object containing props that can be passed to the `Tree`
 * component to handle the expansion state within the tree.
 */
export function useTreeItemExpansion(defaultExpandedIds) {
    var _a = useState(defaultExpandedIds), expandedIds = _a[0], setExpandedIds = _a[1];
    var onItemExpansion = useCallback(function (itemId, expanded) {
        setExpandedIds(function (expandedIds) {
            var nextExpandedIds = expandedIds;
            var i = expandedIds.indexOf(itemId);
            if (i === -1 && expanded) {
                nextExpandedIds = expandedIds.slice();
                nextExpandedIds.push(itemId);
            }
            else if (i !== -1 && !expanded) {
                nextExpandedIds = expandedIds.slice();
                nextExpandedIds.splice(i, 1);
            }
            return nextExpandedIds;
        });
    }, []);
    var onMultiItemExpansion = useCallback(function (itemIds) {
        setExpandedIds(itemIds);
    }, []);
    return {
        expandedIds: expandedIds,
        onItemExpansion: onItemExpansion,
        onMultiItemExpansion: onMultiItemExpansion,
    };
}
//# sourceMappingURL=useTreeItemExpansion.js.map